<template>
  <SignUpTemplate
    :left-image="linkAccount.isLinkAccount ? '/static/assets/images/user-signup.jpg' : '/static/assets/images/business-signup.jpg'"
    left-title="COMPANY"
    left-subtitle="COMPANY"
  >
    <div class="full-width">
      <ul class="navigator pt-6">
        <div class="navigator__wrapper">
          <SignUpBullet
            :done="getStepNumber"
            :form="done"
            :number="1"
            to="./step1"
          />
          <SignUpBullet
            :done="getStepNumber"
            :form="done"
            :number="2"
            to="./step2"
          />
          <SignUpBullet
            :done="getStepNumber"
            :form="done"
            :number="3"
            to="./step3"
          />
        </div>
      </ul>
      <Transition
        :name="transitionClass"
        @on:before-enter="() => lastStep(getStepNumber)"
      >
        <RouterView
          :auth="auth"
          class="content"
        />
      </Transition>
    </div>
  </SignUpTemplate>
</template>
<script>

import { mapState, mapMutations } from 'vuex';
import { SignUpBullet, SignUpTemplate } from '@/domains/Auth/components';
import { COMPANY_MODULE, GENERAL_MODULE } from '@/constants/modules';
import numberOfEmployees from './constants/NumberOfEmployees';

export default {
  components: {
    SignUpBullet,
    SignUpTemplate,
  },
  props: {
    auth: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(COMPANY_MODULE, {
      currentStep: s => s.currentStep,
      done: s => s.done,
      linkAccount: s => s.linkAccount,
      lastStepNumber: s => s.lastStep,
    }),
    getStepNumber() {
      const route = this.$route.name.match(/\d+/);
      return route ? parseInt(route[0], 0) : 1;
    },
    transitionClass() {
      return this.lastStepNumber > this.getStepNumber ? 'slide-fade-fallback' : 'slide-fade';
    },
  },
  created() {
    if (this.$route.query.test === 'true') {
      localStorage.setItem('env_test', true);
    }
    // this.setCompanySize();
  },
  mounted() {
    this.notificationInstance(this.$notifications);
  },
  methods: {
    ...mapMutations(COMPANY_MODULE, [
      'updateStep',
      'notificationInstance',
      'linkAccountUser',
      'isLinkAccount',
      'companySizes',
      'idpUuid',
      'lastStep',
    ]),
    ...mapMutations(GENERAL_MODULE, [
      'locale',
    ]),
    setCompanySize() {
      this.companySizes(numberOfEmployees.map((item) => {
        item.label = this.$t(item.label); // eslint-disable-line no-param-reassign
        return item;
      }));
    },
  },
};
</script>
